var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AddEditCategoryForm',{attrs:{"categoryDetails":_vm.categoryDetails},on:{"onSuccess":_vm.getCategoryDetails}})
}
var staticRenderFns = []

export { render, staticRenderFns }